// extracted by mini-css-extract-plugin
export default {"gitStats":"githubstats_gitStats__oSnjc","reload":"githubstats_reload__TOj8N","bounce":"githubstats_bounce__5NP71","calc":"githubstats_calc__vaPHn"};